import unescapedText from 'I18n/utils/unescapedText';
import I18n from 'I18n';
import { Locale, localeData } from 'moment';

export type LocaleFormat = 'L' | 'YYYY-MM-DD' | 'LL' | 'll';

type LongDateFormatKey =
  | 'LTS'
  | 'LT'
  | 'L'
  | 'LL'
  | 'LLL'
  | 'LLLL'
  | 'lts'
  | 'lt'
  | 'l'
  | 'll'
  | 'lll'
  | 'llll';

type LocaleData = typeof localeData;

interface GetLocaleDataFunction extends LocaleData {
  (key?: string | string[]): Locale & {
    _longDateFormat?: {
      [key: string]: string;
    };
  };
}

type DeprecatedLangDataFunction = {
  langData: LocaleData;
};

type LocaleFormatToStringFunction = (format: LocaleFormat) => string;

/**
 * Returns data for the current user's locale according to MomentJS. It's important that this not
 * be called until I18n is ready. For UIComponents, this means waiting until render.
 */
export const getLocaleData: GetLocaleDataFunction = () => {
  const locale = (I18n.moment.locale || I18n.moment.lang)();
  return (
    I18n.moment.localeData ||
    (I18n.moment as typeof I18n.moment & DeprecatedLangDataFunction).langData
  )(locale);
};

export const getLocalizedDateFormat: LocaleFormatToStringFunction = (
  format
) => {
  const longDateFormat =
    getLocaleData().longDateFormat(format as LongDateFormatKey) || format;
  return longDateFormat;
};

export const getDatePlaceholder: LocaleFormatToStringFunction = (
  format: LocaleFormat
) =>
  getLocalizedDateFormat(format)
    .replace(/MM/, unescapedText('ui.datePicker.placeholder.month'))
    .replace(/DD/, unescapedText('ui.datePicker.placeholder.day'))
    .replace(/YYYY/, unescapedText('ui.datePicker.placeholder.year'));
